import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
import { ConversationsStaticFilterConfig } from '../static/conversationsStaticFilter.types';

/** The list of directions conversations can be filtered by. */
const directions: readonly ConversationsStaticFilterConfig['direction'][] = [
  { id: 'inbound', name: 'Inbound' },
  { id: 'outbound', name: 'Outbound' },
  { id: 'internal', name: 'Internal' },
];

/** Represents the component for filtering the conversations by direction. */
export const ConversationsDirectionFilter = (): JSX.Element => (
  <ConversationsStaticFilter type="direction" items={directions} />
);
